import { useImperativeHandle, useRef } from 'react';
import type { Ref } from 'react';
import type { UploadFile } from 'antd/es/upload';
import type { UploadRef, UseTriggerResult } from './types';

/**
 * 手动触发文件选择
 * @param ref
 * @returns
 */
export function useTrigger(ref: Ref<UploadRef>): UseTriggerResult {
  const uploader = useRef<HTMLDivElement>(null);
  const files = useRef<UploadFile[]>([]);

  useImperativeHandle(ref, () => ({
    open(): void {
      (uploader.current?.querySelector('input[type="file"]') as HTMLInputElement).click();
    },
    delete: (index: number): void => {
      removeFile(index);
    }
  }));

  function setFile(value: UploadFile[]): void {
    files.current = value;
  }

  function removeFile(index: number): void {
    if (files.current == null || files.current.length <= 0) {
      return;
    }
    files.current.splice(index, 1);
    setFile(files.current);
  }

  function getFile(multiple = false): Blob | Blob[] | undefined {
    if (files.current == null || files.current.length <= 0) {
      return;
    }
    if (multiple) {
      return files.current.map(item => item.originFileObj) as Blob[];
    }
    // 返回最新上传的文件
    return files.current[files.current?.length - 1].originFileObj as Blob;
  }

  return { uploader, getFile, setFile };
}
